import actions from './actions';
import mutations from './mutations';

export const makeInitialState = () => ({
  orgId: null,
  data: [],
  inviteCodes: {},
});

export default {
  namespaced: true,
  state: makeInitialState(),
  actions,
  mutations,
  getters: {
    orgId: state => state.orgId,
    inviteLink: state => (
      state.inviteCodes[state.orgId] ? `${window.location.origin}/join?code=${state.inviteCodes[state.orgId]}` : null),
  },
  hagridOn: {
    logout: 'clear',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/orgs/index.js